import "./SubscriptionsPage.css";

import { ModalContext } from "../../store/ModalContext";
import { SubscriptionsContext } from "../../store/SubscriptionsContext";
import { SeasonContext } from "../../store/SeasonContext";
import { useContext } from "react";
import TierList from "./components/TierList";
import { CreateSubscriptionModalBody } from "./modals/CreateSubscriptionModalBody";
import { EditSubscriptionModalBody } from "./modals/EditSubscriptionModalBody";
import { CreateTierModalBody } from "./modals/CreateTierModalBody";
import { EditTierModalBody } from "./modals/EditTierModalBody";
import { ApplicationPeriod } from "../../../../api/season";
//TODO should not depend on season
const SubscriptionsPage = () => {
  const { subscriptions, tiers } = useContext(SubscriptionsContext);
  const { openModal, closeModal } = useContext(ModalContext);
  const { areWeInSeason, applicationPeriod } = useContext(SeasonContext);

  function handleCannotEditWarning() {
    openModal({
      title: "WARNING",
      body: "You cannot create or edit subscriptions and tiers during the season.",
      showCloseButton: true,
    });
  }

  return (
    <div className="page-container">
      <h1>CSA Subscriptions</h1>

      <div className="btn-aligned-right-box">
        <button
          className={
            applicationPeriod === ApplicationPeriod.ApplicationClosed &&
            !areWeInSeason
              ? "btn btn-aligned-right"
              : "btn btn-aligned-right disabled-btn"
          }
          onClick={() => {
            areWeInSeason ||
            applicationPeriod !== ApplicationPeriod.ApplicationClosed
              ? handleCannotEditWarning()
              : openModal({
                  title: "Create Subscription",
                  showCloseButton: true,
                  body: (
                    <CreateSubscriptionModalBody
                      onClose={closeModal}
                      openMessage={openModal}
                    />
                  ),
                });
          }}
        >
          Add Subscription Type
        </button>
      </div>
      <div className="page-content">
        <TierList
          onEditAndCreateWarning={handleCannotEditWarning}
          onEditSubscription={(subscriptionId) => {
            const sub = subscriptions.find((s) => s.id === subscriptionId);
            if (!sub) return;
            openModal({
              title: (
                <>
                  {sub.name}
                  <br />
                  Edit Subscription
                </>
              ),
              showCloseButton: true,
              body: (
                <EditSubscriptionModalBody
                  activeSubscription={sub}
                  onClose={closeModal}
                  openMessage={openModal}
                />
              ),
            });
          }}
          onCreateTier={(subscriptionId) => {
            const sub = subscriptions.find((s) => s.id === subscriptionId);
            if (!sub) return;
            openModal({
              showCloseButton: true,
              body: (
                <CreateTierModalBody activeSub={sub} onClose={closeModal} />
              ),
            });
          }}
          onEditTier={(tierId) => {
            const tier = tiers.find((t) => t.id === tierId);
            if (!tier) return;
            openModal({
              showCloseButton: true,
              body: <EditTierModalBody tierId={tierId} onClose={closeModal} />,
            });
          }}
          areWeInSeason={areWeInSeason}
          applicationPeriod={applicationPeriod}
        />
      </div>
    </div>
  );
};

export default SubscriptionsPage;
